export const getHash = () => {
	const timestamp = new Date().getTime();
	return `${Math.random().toString(20).substr(2, 15)}${timestamp}`;
};
